
import { useState, useEffect } from "react";

function Section({ tab, setTab, textContent }) {

  const [arrayWhyChooseUsePoints, setArrayWhyChooseUsePoints] = useState([]);
  const [arrayOurServicesPoints, setArrayOurServicesPoints] = useState([]);
  const [arrayOurEngagementBenefits, setArrayOurEngagementBenefits] = useState([]);
  const [arrayCostSavingsPoints, setArrayCostSavingsPoints] = useState([]);
  const [arrayAdditionalServices, setArrayAdditionalServices] = useState([]);
  
  useEffect(() => {
  setArrayWhyChooseUsePoints(textContent?.ourExpertise?.whyChooseUs?.points || []);
  setArrayOurServicesPoints(textContent?.ourExpertise?.ourServices?.services || []);
  setArrayOurEngagementBenefits(textContent?.ourExpertise?.ourEngagement?.benefits || []);  
  setArrayCostSavingsPoints(textContent?.ourExpertise?.costSavings?.points || []);
  setArrayAdditionalServices(textContent?.ourExpertise?.additionalServices?.services || []);
  }, [textContent?.ourExpertise?.whyChooseUs?.points]);

  return (
    <section
      className={`tab-content ${tab === 1 ? "active" : ""}`}
      id="tab-expertise"
    >
      <div className="section-content">
        <img src="images/9689394.webp" alt="Expertise" />
        <div className="section-text">
          <h2>{textContent?.ourExpertise?.expertise?.heading}</h2>
          <ul className="service-list">
            {textContent?.ourExpertise?.expertise?.items.map((service, index) => (
              <li key={index} className="service-item">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </li>
            ))}
          </ul>

          <div className="section-text s-t">
            <h2>{textContent?.ourExpertise?.whyChooseUs?.heading}</h2>
            <ul className="service-list">
              
              {arrayWhyChooseUsePoints.map((reason, index) => (
                <li key={index} className="service-item">
                  <h3>{reason.title}</h3>
                  <p>{reason.description}</p>
                </li>
              ))}

            </ul>

            <h2>{textContent?.ourExpertise?.ourServices?.title}</h2>
            <ul>
              {arrayOurServicesPoints.map((service, index) => (
                <li className="service-item">
                <h3>{service.name}</h3>
                <p>
                  {service.description}
                </p>
              </li>
              ))}
            </ul>
            <br />
            <p>
              {textContent?.ourExpertise?.partnerWithUs?.description}
            </p>
            <p>
              {textContent?.ourExpertise?.partnerWithUs?.callToAction}
            </p>

            <h2>{textContent?.ourExpertise?.ourEngagement?.title}</h2>
            <ul>
              {arrayOurEngagementBenefits.map((benefit, index) => (
                <li className="service-item">
                <h3>{benefit.title}</h3>
                {benefit.description}
              </li>
              ))}
            </ul>

            <img src="images/expertise/1.webp" alt="hands-team" />
            <br />

            <strong>
              {textContent?.ourExpertise?.ourEngagement?.closingNote}
            </strong>

            <br />
            <br />
            <h2 style={{ color: "whitesmoke" }}>
              {textContent?.ourExpertise?.costSavings?.title}
            </h2>
            <ul>
              {arrayCostSavingsPoints.map((saving, index) => (
                <li className="service-item">
                <h3>{saving.title}</h3>
                <p>
                  {saving.description}
                </p>
              </li>
              ))}
            </ul>

            <br />

            <h2 style={{ color: "whitesmoke" }}>
              {textContent?.ourExpertise?.additionalServices?.title}
            </h2>
            <ul>
              {arrayAdditionalServices.map((service, index) => (
                <li className="service-item">
                <p>
                  {service}
                </p>
              </li>
              ))}
            </ul>
          </div>

          <button className="cta-button" onClick={() => setTab(2)}>
            {textContent?.ourExpertise?.additionalServices?.cta}
          </button>
        </div>
      </div>
    </section>
  );
}

export default Section;
